/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GarageSpotEquipmentStatusFromJSON, GarageSpotEquipmentStatusToJSON, } from './';
export function CarEquipmentDtoFromJSON(json) {
    return CarEquipmentDtoFromJSONTyped(json, false);
}
export function CarEquipmentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'garageSpotId': !exists(json, 'garageSpotId') ? undefined : json['garageSpotId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'addedDate': !exists(json, 'addedDate') ? undefined : (new Date(json['addedDate'])),
        'status': !exists(json, 'status') ? undefined : GarageSpotEquipmentStatusFromJSON(json['status']),
    };
}
export function CarEquipmentDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'garageSpotId': value.garageSpotId,
        'name': value.name,
        'description': value.description,
        'quantity': value.quantity,
        'location': value.location,
        'addedDate': value.addedDate === undefined ? undefined : (value.addedDate.toISOString()),
        'status': GarageSpotEquipmentStatusToJSON(value.status),
    };
}
